/* NÖR v3 — shared behaviours for the split home sections.
   Safe to include from every section: init is idempotent and
   re-runs on shopify:section:load for the theme editor. */
(function () {
  if (window.__NOR2_INIT__) { window.__NOR2_INIT__(document); return; }

  var io = null;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function initFaq(root) {
    each(root.querySelectorAll('.n2-faq'), function (group) {
      if (group.getAttribute('data-n2-ready')) return;
      group.setAttribute('data-n2-ready', '1');
      var items = group.querySelectorAll('[data-n2-faq]');
      each(items, function (item) {
        var q = item.querySelector('.n2-faq-q');
        if (!q) return;
        q.addEventListener('click', function () {
          var wasOpen = item.classList.contains('is-open');
          each(items, function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('.n2-faq-q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (!wasOpen) {
            item.classList.add('is-open');
            q.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  function initRails(root) {
    each(root.querySelectorAll('.n2-rail-wrap'), function (wrap) {
      if (wrap.getAttribute('data-n2-ready')) return;
      var rail = wrap.querySelector('[data-n2-rail]');
      if (!rail) return;
      wrap.setAttribute('data-n2-ready', '1');

      var fill = wrap.querySelector('[data-n2-rail-fill]');
      var prev = wrap.querySelector('[data-n2-rail-prev]');
      var next = wrap.querySelector('[data-n2-rail-next]');
      var step = function () { return Math.max(rail.clientWidth * 0.7, 240); };
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });

      var updateFill = function () {
        if (!fill) return;
        var max = rail.scrollWidth - rail.clientWidth;
        var frac = rail.clientWidth / rail.scrollWidth;
        fill.style.width = (frac * 100) + '%';
        var pos = max > 0 ? rail.scrollLeft / max : 0;
        fill.style.transform = 'translateX(' + (pos * (1 - frac) / frac * 100) + '%)';
      };

      var dotsBox = wrap.querySelector('[data-n2-rail-dots]');
      var dots = [];
      var cardStep = function () {
        var first = rail.children[0];
        return first ? first.offsetWidth + 14 : 1;
      };
      if (dotsBox && !dotsBox.children.length) {
        each(rail.children, function (card, i) {
          var d = document.createElement('button');
          d.className = 'n2-rail-dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to item ' + (i + 1));
          d.addEventListener('click', function () {
            rail.scrollTo({ left: i * cardStep(), behavior: 'smooth' });
          });
          dotsBox.appendChild(d);
          dots.push(d);
        });
      }
      each(wrap.querySelectorAll('[data-n2-jump]'), function (d) {
        var i = parseInt(d.dataset.n2Jump, 10);
        d.addEventListener('click', function () {
          rail.scrollTo({ left: i * cardStep(), behavior: 'smooth' });
        });
        dots.push(d);
      });

      var updateDots = function () {
        if (!dots.length) return;
        var idx = Math.round(rail.scrollLeft / cardStep());
        dots.forEach(function (d) {
          var i = d.dataset.n2Jump !== undefined ? parseInt(d.dataset.n2Jump, 10) : Array.prototype.indexOf.call(d.parentElement.children, d);
          d.classList.toggle('is-active', i === idx);
        });
      };

      var onScroll = function () { updateFill(); updateDots(); };
      rail.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    });
  }

  function initReveal(root) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = root.querySelectorAll('.n2-reveal:not([data-n2-seen])');
    if (!targets.length) return;
    each(targets, function (t) { t.setAttribute('data-n2-seen', '1'); });
    if (reduced || !('IntersectionObserver' in window)) {
      each(targets, function (t) { t.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    each(targets, function (t) { io.observe(t); });
  }

  function init(root) {
    root = root || document;
    initFaq(root);
    initRails(root);
    initReveal(root);
  }

  window.__NOR2_INIT__ = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
